import type { CalendarProvider } from '@gap/backend/app-services/calendar/models/CalendarEnums'
import { ActiveIntegrations, Analytics } from './analytics'

export enum CalendarAnalyticsEvent {
   calendarConnected = 'Calendar connected',
   calendarDisconnected = 'Calendar disconnected',
}

/** Maps a calendar provider to its Mixpanel display name and org active integration. */
function providerDetails(provider: CalendarProvider) {
   switch (provider) {
      case 'google':
         return { name: 'Google', activeIntegration: ActiveIntegrations.GoogleCalendar }
      case 'outlook':
         return { name: 'Outlook', activeIntegration: ActiveIntegrations.OutlookCalendar }
   }
}

export default class CalendarAnalytics implements Analytics {
   /** Emits `Calendar connected` and adds the provider to the org's active integrations. */
   static connected = async (params: { provider: CalendarProvider, orgId: string | undefined }) => {
      const { name, activeIntegration } = providerDetails(params.provider)
      Analytics.emitEvent(CalendarAnalyticsEvent.calendarConnected, { Provider: name })
      if (params.orgId) await Analytics.setActiveIntegrations(params.orgId, { [activeIntegration]: true })
   }

   /** Emits `Calendar disconnected` and removes the provider from the org's active integrations. */
   static disconnected = async (params: { provider: CalendarProvider, orgId: string | undefined }) => {
      const { name, activeIntegration } = providerDetails(params.provider)
      Analytics.emitEvent(CalendarAnalyticsEvent.calendarDisconnected, { Provider: name })
      if (params.orgId) await Analytics.setActiveIntegrations(params.orgId, { [activeIntegration]: false })
   }
}
